import { cabinClassRank } from '../../constants';

const checkDoFlightHaveCabinDowngrade = (
  usePreferredCabin, highestRankedCabin, flightOriginalCabinClass,
) => {
  const cabinToMatch = usePreferredCabin || usePreferredCabin === ''
    ? usePreferredCabin : highestRankedCabin;
  return cabinClassRank[flightOriginalCabinClass] < cabinClassRank[cabinToMatch];
};

export default checkDoFlightHaveCabinDowngrade;
